export const validCPFOrCNPJ = (document: string): boolean => {
  document = document.replace(/\D/g, '');
  if (document.length === 11) {
    return validCPF(document);
  } else {
    return validCNPJ(document);
  }
};

export const validCPF = (cpf: string): boolean => {
  cpf = cpf.replace(/\D/g, '');
  let rest: number;
  let sum = 0;

  if (cpf.length !== 11) {
    return false;
  }

  const firstChar = cpf[0];
  if (cpf.split(firstChar).length === 12) {
    return false;
  }

  for (let i = 1; i <= 9; i++) {
    sum = sum + +cpf.substring(i - 1, i) * (11 - i);
  }
  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== +cpf.substring(9, 10)) {
    return false;
  }

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum = sum + +cpf.substring(i - 1, i) * (12 - i);
  }
  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== +cpf.substring(10, 11)) {
    return false;
  }

  return true;
};

export const validCNPJ = (cnpj: string): boolean => {
  if (!cnpj) return false;

  // Aceita receber o valor como string, número ou array com todos os dígitos
  const isString = typeof cnpj === 'string';
  const validTypes = isString || Number.isInteger(cnpj) || Array.isArray(cnpj);

  // Elimina valor em formato inválido
  if (!validTypes) return false;

  // Filtro inicial para entradas do tipo string
  if (isString) {
    // Limita ao máximo de 18 caracteres, para CNPJ formatado
    if (cnpj.length > 18) return false;

    // Teste Regex para veificar se é uma string apenas dígitos válida
    const digitsOnly = /^\d{14}$/.test(cnpj);
    // Teste Regex para verificar se é uma string formatada válida
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(cnpj);

    // Se o formato é válido, usa um truque para seguir o fluxo da validação
    if (digitsOnly || validFormat) true;
    // Se não, retorna inválido
    else return false;
  }

  // Guarda um array com todos os dígitos do valor
  const match = cnpj.toString().match(/\d/g);
  const numbers = Array.isArray(match) ? match.map(Number) : [];

  // Valida a quantidade de dígitos
  if (numbers.length !== 14) return false;

  // Elimina inválidos com todos os dígitos iguais
  const items = [...new Set(numbers)];
  if (items.length === 1) return false;

  // Cálculo validador
  const calc = (x: any) => {
    const slice = numbers.slice(0, x);
    let factor = x - 7;
    let sum = 0;

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }

    const result = 11 - (sum % 11);

    return result > 9 ? 0 : result;
  };

  // Separa os 2 últimos dígitos de verificadores
  const digits = numbers.slice(12);

  // Valida 1o. dígito verificador
  const digit0 = calc(12);
  if (digit0 !== digits[0]) return false;

  // Valida 2o. dígito verificador
  const digit1 = calc(13);
  return digit1 === digits[1];
};

export const formatCPFOrCNPJ = (document: string): string => {
  document = document.replace(/\D/g, '');
  if (document.length === 11) {
    return formatCPF(document);
  } else {
    return formatCNPJ(document);
  }
};

export const formatCNPJ = (cnpj: string): string => {
  if (cnpj.length <= 18) {
    cnpj = cnpj.replace(/\D/g, '');
    cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
    cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
    cnpj = cnpj.replace(/(-\d{2})\d+?$/, '$1');
  }
  return cnpj.slice(0, 18);
};

export const formatCPF = (cpf: string): string => {
  if (cpf.length <= 14) {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})/, '$1-$2');
    cpf = cpf.replace(/(-\d{2})\d+?$/, '$1');
  }
  return cpf.slice(0, 14);
};

export const hideNumbersCPF = (cpf: string): string => {
  if (
    cpf &&
    cpf.length === 14 &&
    cpf.charAt(3) === '.' &&
    cpf.charAt(7) === '.' &&
    cpf.charAt(11) === '-'
  ) {
    return cpf.replace(cpf.substring(3, 11), '.***.***');
  } else {
    return cpf;
  }
};
